/**
 * Список стран, поддерживающих Украину.
 * @type { Array }
 * @property { String } "UA" - "Ukraine"
 * @property { String } "AT" - "Austria"
 * @property { String } "BE" - "Belgium"
 * @property { String } "BG" - "Bulgaria"
 * @property { String } "HR" - "Croatia"
 * @property { String } "CY" - "Cyprus"
 * @property { String } "CZ" - "Czech Republic"
 * @property { String } "DK" - "Denmark"
 * @property { String } "EE" - "Estonia"
 * @property { String } "FI" - "Finland"
 * @property { String } "FR" - "France"
 * @property { String } "DE" - "Germany"
 * @property { String } "GR" - "Greece"
 * @property { String } "HU" - "Hungary"
 * @property { String } "IS" - "Iceland"
 * @property { String } "IE" - "Ireland"
 * @property { String } "IT" - "Italy"
 * @property { String } "LV" - "Latvia"
 * @property { String } "LT" - "Lithuania"
 * @property { String } "LU" - "Luxembourg"
 * @property { String } "MT" - "Malta"
 * @property { String } "NL" - "Netherlands"
 * @property { String } "NO" - "Norway"
 * @property { String } "PL" - "Poland"
 * @property { String } "PT" - "Portugal"
 * @property { String } "RO" - "Romania"
 * @property { String } "SK" - "Slovakia"
 * @property { String } "SI" - "Slovenia"
 * @property { String } "ES" - "Spain"
 * @property { String } "SE" - "Sweden"
 * @property { String } "CH" - "Switzerland"
 * @property { String } "GB" - "United Kingdom"
 * @property { String } "AL" - "Albania"
 * @property { String } "BA" - "Bosnia and Herzegovina"
 * @property { String } "GE" - "Georgia"
 * @property { String } "IL" - "Israel"
 * @property { String } "XK" - "Kosovo"
 * @property { String } "MK" - "North Macedonia"
 * @property { String } "MD" - "Moldova"
 * @property { String } "MC" - "Monaco"
 * @property { String } "ME" - "Montenegro"
 * @property { String } "SM" - "San Marino"
 * @property { String } "RS" - "Serbia"
 * @property { String } "TR" - "Turkey"
 */
export const COUNTRIES_SUPPORT_UKRAINE = [
    "UA",
    "AT",
    "BE",
    "BG",
    "HR",
    "CY",
    "CZ",
    "DK",
    "EE",
    "FI",
    "FR",
    "DE",
    "GR",
    "HU",
    "IS",
    "IE",
    "IT",
    "LV",
    "LT",
    "LU",
    "MT",
    "NL",
    "NO",
    "PL",
    "PT",
    "RO",
    "SK",
    "SI",
    "ES",
    "SE",
    "CH",
    "GB",
    "AL",
    "BA",
    "GE",
    "IL",
    "XK",
    "MK",
    "MD",
    "MC",
    "ME",
    "SM",
    "RS",
    "TR",
];

/**
 * Список кодов языков для перевода.
 * @type { Array }
 * @property {String} "ua" - "Ukrainian"
 * @property {String} "ru" - "Russian"
 * @property {String} "en" - "English"
 */

export const TRANSLATE_LANGUAGES = ["ua", "ru", "en"];
